import { useEffect, useState } from "react";
import { Navigate } from "react-router";
import { uuidToShortId } from "../../utils/uuid-to-short-id";

import type { FC } from "react";

const PagesNewPage: FC = () => {
  const [shortId, setShortId] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    void uuidToShortId(crypto.randomUUID()).then((id) => {
      if (isMounted) setShortId(id);
    });
    return () => {
      isMounted = false;
    };
  }, []);

  if (!shortId) return null;
  return <Navigate replace to={`/pages/${shortId}`} />;
};

export default PagesNewPage;
